export default "__VITE_ASSET__73tQyGJj__"